import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ResourceThumbnailTooltip } from 'src/components/ResourceThumbnailTooltip';
import { ResourceTypeIcon } from 'src/components/ResourceTypeIcon';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { PROMPT_ACTION } from 'src/data/prompt';

import { BaseMenuItem } from '../BaseMenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

export const MenuItemResource = ({ className, item, onAction }) => {
  const styles = useStyles();

  const handleClick = useCallback(() => {
    onAction(PROMPT_ACTION.insertFileResource, { resource: item.resource });
  }, [item, onAction]);

  const handleTooltipClick = useCallback(() => {
    onAction(PROMPT_ACTION.openResourceInNewTab, { resource: item.resource });
  }, [item, onAction]);

  return (
    <ResourceThumbnailTooltip
      label={item.label}
      onClick={handleTooltipClick}
      thumbnailUrl={item.resource?.file?.thumbnailUrl}
      placement="right"
    >
      <BaseMenuItem
        className={cx(styles.root, className)}
        item={item}
        onClick={handleClick}
      >
        {!item.title && !item.emptyState && (
          <ResourceTypeIcon
            className={styles.assetIcon}
            type={item.resource?.contentType}
            fileType={item.resource?.file?.fileType}
            small
          />
        )}

        <div className={styles.content}>
          {item.label && (
            <TruncatedTypography
              className={styles.label}
              variant={TYPOGRAPHY_VARIANT.medium14}
              hideTooltip
            >
              {item.label}
            </TruncatedTypography>
          )}

          <TruncatedTypography
            className={styles.body}
            variant={TYPOGRAPHY_VARIANT.regular12}
            hideTooltip
          >
            {item.subtitle} {item.brandVoiceName && ' • ' + item.brandVoiceName}
          </TruncatedTypography>

          {item.body && (
            <TruncatedTypography
              className={styles.body}
              variant={TYPOGRAPHY_VARIANT.regular12}
              hideTooltip
            >
              {item.body}
            </TruncatedTypography>
          )}
        </div>
      </BaseMenuItem>
    </ResourceThumbnailTooltip>
  );
};

MenuItemResource.propTypes = propTypes;
MenuItemResource.defaultProps = defaultProps;
